module.exports = __webpack_public_path__ + "static/media/slide_puzzle.68daa286.gif";